import { render, staticRenderFns } from "./BackOffice.vue?vue&type=template&id=689e84be&scoped=true"
import script from "./BackOffice.vue?vue&type=script&lang=js"
export * from "./BackOffice.vue?vue&type=script&lang=js"
import style0 from "./BackOffice.vue?vue&type=style&index=0&id=689e84be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689e84be",
  null
  
)

export default component.exports